import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";

// Vision UI Dashboard React example components
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";

// React icons
import { IoGlobe } from "react-icons/io5";
import { IoWallet } from "react-icons/io5";
import { IoLogoUsd } from "react-icons/io5";
import { IoReceiptSharp } from "react-icons/io5";

// Moralis
import { useMoralis, useNativeBalance } from "react-moralis";
import { getChainName, getExplorer, getNativeByChain } from "helpers/networks";

function AuthUser() {
  // use moralis to connect wallet
  const { account, chainId } = useMoralis();
  const { data: balance } = useNativeBalance();

  const getNetworkName = getChainName(chainId);
  const blockExplorer = getExplorer(chainId);
  const getCurrencyChain = getNativeByChain(chainId);

  return (
    <VuiBox mb={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} xl={3}>
          <MiniStatisticsCard
            title={{ text: "Wallet Address", fontWeight: "regular" }}
            count={account.slice(0, 6) + " ... " + account.slice(-4)}
            icon={{ color: "info", component: <IoWallet size="22px" color="white" /> }}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <MiniStatisticsCard
            title={{ text: "Network" }}
            count={getNetworkName}
            icon={{ color: "info", component: <IoGlobe size="22px" color="white" /> }}
          />
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <a href={blockExplorer} target="_blank">
            <MiniStatisticsCard
              title={{ text: "Blockchain Explorer" }}
              count={getCurrencyChain + " Explorer"}
              icon={{ color: "info", component: <IoReceiptSharp size="22px" color="white" /> }}
            />
          </a>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <MiniStatisticsCard
            title={{ text: "Balance" }}
            count={balance.formatted}
            icon={{ color: "info", component: <IoLogoUsd size="22px" color="white" /> }}
          />
        </Grid>
      </Grid>
    </VuiBox>
  );
}

export default AuthUser;
